import React from 'react'
import LinkMediaSideNav from './LinkMediaSideNav'
import LinkMedia from './LinkMedia'

function Linkmediamain() {
  const sideNav={
    padding: "10px 15px 0",
    height: "100%",
    boxSizing: "border-box"
  }
  return (
    <div className='flex'>
      <div style={{ flex: '1 1 280px', textAlign:'left' }}>
        <div style={sideNav}>
    <LinkMediaSideNav />
    </div>
    </div>

    
    </div>
  )
}

export default Linkmediamain